
const Footer = () => {
    return (
        <>

            <footer class="text-center text-lg-start bg-white text-muted">

                <section style={{ "backgroundColor": "rgba(0, 0, 0, 0.025)" }} class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">





                </section>

                <section class="">
                    <div class="container text-center text-md-start mt-5">

                        <div class="row mt-3">

                            <div class="col-md-3 col-lg-4 col-xl-6 mx-auto mb-4 ">
                                <div className="img_gerb ">
                                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Coat_of_arms_of_Tajikistan_.svg/1200px-Coat_of_arms_of_Tajikistan_.svg.png" height={80} />
                                </div>
                                <p className='pt-3 footer_text'>
                                    © 2016 - 2022 Вазорати маориф ва илми Ҷумҳурии Тоҷикистон.
                                    734024, шаҳри Душанбе, кӯчаи Нисормуҳаммад, 13а, телефон: 221-46-05 факс: 221-70-41; www.maorif.tj, Е-mail: mort@maorif.tj
                                </p>
                            </div>

                            <div class="col-md-4 col-lg-3 col-xl-4 mx-auto mb-md-0 mb-4 footer_text_address" >
                                <h6 class="text-uppercase fw-bold mb-4">Cуроға</h6>
                                <p><i class="fas fa-home me-3 text-grayish"></i> шаҳри Душанбе, кӯчаи Нисормуҳаммад, 13а,</p>
                                <p>
                                    <i class="fas fa-envelope me-3 text-grayish"></i>
                                    Е-mail: mort@maorif.tj
                                </p>
                                <p><i class="fas fa-phone me-3 text-grayish"></i> + (992) 221-46-05</p>
                                <p><i class="fas fa-print me-3 text-grayish"></i> + (992) 221-70-41</p>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="text-center p-4" style={{ "backgroundColor": "rgba(0, 0, 0, 0.025)", fontSize: "11px" }} >
                    © 2022 Все права защищены.

                </div>
            </footer>
        </>
    )
}

export default Footer;